// Generated by genversion.
export const version = '10.0.2';
//# sourceMappingURL=version.js.map